import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Permission } from "components";
import { setPermission } from "../services/common/actions";

export default function roleHOC(ImportComponent) {
	return (props) => {

		let hasPermissions = useSelector(({ common: { hasPermissions } }) => hasPermissions);
		let dispatch = useDispatch()

		useEffect(() => {
			return () => {
				dispatch(setPermission(true))
			}
		}, [])

		return hasPermissions ? <ImportComponent {...props} /> : <Permission />;
	}
}
